import { ApiClientService, EntityApiService, RequestConfig, SearchResponseType } from '@dfl/react-security';
import { InFilter } from '@dofleini/query-builder';
import { IProductDiscount } from 'modules/sales-offer/product-discount/interfaces';

class ProductDiscountService extends EntityApiService<IProductDiscount> {
  createFromTxt = (file: File, dto: Partial<IProductDiscount>): Promise<{ offer: IProductDiscount; notFoundCodes: string[] }> => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('data', JSON.stringify(dto));
    return ApiClientService.post(this.getPath('/from-txt'), formData).then((r) => r.data);
  };

  removeProduct = (productDiscountId: string, products: any) => {
    return ApiClientService.patch(this.getPath(`/${productDiscountId}/remove`), {
      filters: new InFilter({ field: '_id', value: products, objectId: true }),
    });
  };

  addProduct = (productDiscountId: string, products: any, search?: any) => {
    return ApiClientService.patch(this.getPath(`/${productDiscountId}/add`), {
      filters: products,
      search,
    });
  };

  addProductFromTxt = (productDiscountId: string, file: File): Promise<{ modifiedCount: number; notFoundCodes: string[] }> => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return ApiClientService.patch(this.getPath(`/${productDiscountId}/add-from-txt`), formData).then((r) => r.data);
  };

  updateStatus = (productDiscountId: string, enabled: boolean) => {
    return ApiClientService.patch(this.getPath(`/${productDiscountId}/enabled`), {
      enabled,
    });
  };

  searchAndActiveSelect = (
    activeOfferId?: string,
    params?: any,
    config?: RequestConfig,
  ): Promise<SearchResponseType<IProductDiscount[]>> => {
    const size = params?.size || 20;
    return this.handleSearchResponse(ApiClientService.post(this.getPath('/search '), params, config), size).then(
      (data) => {
        return parserManyProductDiscount(data, activeOfferId);
      },
    );
  };
}

export default new ProductDiscountService('/ms-sales/api/product-offers');

export const parserManyProductDiscount = (
  data: SearchResponseType<any>,
  activeOfferId?: string,
): SearchResponseType<any> => {
  data.data = data.data.map((offer) => {
    return parser({ ...offer, dflRowClass: '', activeOfferId });
  });
  return data;
};

const parser = (offer: IProductDiscount & { dflRowClass: string; activeOfferId: string }) => {
  if (offer?._id === offer.activeOfferId) {
    offer.dflRowClass = 'row-success';
  }

  return offer;
};
